<div class="w-full">
    <mat-dialog-content>
        <h2 mat-dialog-title>{{ title | translate }}</h2>
        <p>{{ text | translate }}</p>
        <form [formGroup]="form" class="pb-4">
            <p *ngIf="!data.length">{{ 'NOREF' | translate }}</p>
            <app-autocomplete-filter class="items-center" [placeholder]="placeholder | translate" [label]="label | uppercase | translate" [error]="error | uppercase | translate" [control]="this.controls['data']" [options]="data" [accessor]="display" [isLoading]="loading"></app-autocomplete-filter>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions class="flex justify-between w-full">
        <button mat-flat-button mat-dialog-close class="flex-grow bg-tw-disabled">{{'CANCEL'|translate}}</button>
        <button mat-flat-button [mat-dialog-close]="true" class="flex-grow bg-tw-primary text-tw-text-light" [disabled]="!isValid" (click)="save()"> {{ valid|translate }} </button>
    </mat-dialog-actions>
</div>